module.exports = __webpack_public_path__ + "static/media/arrow.7d31d711.svg";